import Joi, { number } from '@hapi/joi'

export const duplicateTagValidationFilteringSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select the group `,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please select the operationEntity`,
        "any.required": `OperationEntityID required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Please select the collectionPointID`,
        "any.required": `OperationEntityID required`
    }),
    date: Joi.string().label("Date").allow(""),
    customerID: Joi.number().label("Customer"),
}

export const duplicateTagValidationSchemaObject = {
    tagNumber: Joi.string().invalid("").required().label("Tag Number").messages({
        "any.invalid": `Invalid tag number `,
        "any.required": `Tag number required`
    }),
    grossAmount: Joi.number().label("Gross Amount"),
    netAmount: Joi.number().label("Net Amount"),
    actualAmount: Joi.number().label("Actual Amount"),
    totalDeduction: Joi.number().label("Total Deduction"),
    tagReadGPS: Joi.string().label("Tag Read GPS"),
    weightReadGPS: Joi.string().label("Weight Read GPS"),

}

